<template lang="pug">
  .dropdown-animate.overflow-hidden(:style="{transition: `max-height ${speed}ms`, maxHeight: expanded ? `${bodyHt}px` : 0}")
    div(ref="body")
      slot
</template>

<script>
export default {
  name: 'DropdownAnimate',
  props: {
    speed: { type: String, default: '500' },
    open: { type: Boolean, default: false }
  },
  data () {
    return {
      expanded: false,
      bodyHt: '0'
    }
  },
  methods: {
    expand () {
      this.bodyHt = this.$refs.body.offsetHeight
      this.$nextTick(() => {
        this.expanded = true
      })
    },
    collapse () {
      this.expanded = false
    }
    // toggle () {
    //   if (!this.expanded) {
    //     this.bodyHt = this.$refs.body.offsetHeight
    //     this.$nextTick(() => {
    //       this.expanded = true
    //     })
    //   } else {
    //     this.expanded = false
    //   }
    // }
  },
  watch: {
    open (open) {
      return open ? this.expand() : this.collapse()
    }
  }
}
</script>

<style>
</style>
